<template>
  <div class="rule-wrap">
    <back-button />
    <div class="rule-main">
      <div class="rule-title">规则说明</div>
      <div class="rule-content">
        1.2025年山西省公众科学素质网络知识竞赛于2025年9月1日正式开始，正式比赛持续时间为56天（共8周）。<br />
        2.全国用户均可参与竞赛，参赛者进入大赛主页后需授权微信登录，提交所在地区信息（选择所在的省、市、区县、乡镇街道）用作成绩统计。<br />
        3.系统将从竞赛题库中随机抽取5道题进行问答，竞赛题型全部为单选题，答对1题计1分，答错或未答题目不计分，每题答题时间为30秒（时间结束后，未做出选择，系统自动显示正确答案并记录成绩）<br />
        4.参赛者每天答题次数最多为30次，每日参与竞赛答题后，可将成绩结果进行分享。<br />
        5.完成每轮答题后，答对4题及以上可参与抽奖。<br />
        注：请首先在微信内完成实名认证，否则中奖红包将无法发放至授权登录的微信账户内。<br />
        6.个人成绩排名将以竞赛题目累计分数进行计算。分数相同，则按累计用时较少者排名靠前。<br />
        7.技术支持电话：010-63581772<br />
      </div>
    </div>
  </div>
</template>
<script>
import BackButton from "@/components/BackButton.vue";
export default {
  components: {
    BackButton,
  },
};
</script>
<style lang="scss" scoped>
.rule-wrap {
  box-sizing: border-box;
  height: 100vh;
  padding: 25px 20px 20px;
  overflow: hidden;
  @include plain-bg;
  @include safe-area-bottom("20px");

  .rule-main {
    position: relative;
    box-sizing: border-box;
    height: 100%;
    padding: 57px 22px 36px;
    font-size: 15px;
    font-weight: 400;
    line-height: 32px;
    color: $black;
    background-color: $white;
    border-radius: 8px;

    .rule-title {
      position: absolute;
      top: -18px;
      right: 0;
      left: 0;
      width: 155px;
      height: 64px;
      padding-top: 18px;
      margin-right: auto;
      margin-left: auto;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 25px;
      color: #fff;
      text-align: center;
      text-shadow: 0 2px 2px #a57afb;
      text-transform: none;
      background: url("~@/assets/img/rule-title-bg.png") no-repeat center
        center/100% 100%;
    }

    .rule-content {
      height: 100%;
      margin-top: 12px;
      overflow: auto;
      text-align: justify;

      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
}
</style>
